"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEnum = exports.filterEnum = exports.createEnum = exports.listToEnum = void 0;
/**
 * Convert a list of strings to an "enum" object
 * @param attributes - The attributes of the enum
 * @returns The input to become an enum
 */
function listToEnum(attributes) {
    const init = {};
    return attributes.reduce((acc, val) => {
        acc[val] = val;
        return acc;
    }, init);
}
exports.listToEnum = listToEnum;
/**
 * Create an enum object with a proxy handler that will throw an error when a property is access that is not in the enum
 * @param attributes - The enums to merge into a single enum (all properties)
 * @returns The object proxy with error logger when a value is accessed outside of enum
 */
function createEnum(...attributes) {
    // Convert all to enums to objects
    const objAttributes = attributes.map((attrs) => Array.isArray(attrs) ? listToEnum(attrs) : attrs);
    return Object.assign({}, ...objAttributes);
}
exports.createEnum = createEnum;
/**
 * Filter an enum and return the keys that remain
 * @param obj - The object to filter
 * @param filterFunc - The function to filter the enum key/values by
 * @returns The object keys that remained
 */
function filterEnum(obj, filterFunc) {
    return (Object.keys(obj)
        // Filter by value
        .filter((key) => filterFunc(obj[key], key, obj))
        // Return keys
        .map((key) => key));
}
exports.filterEnum = filterEnum;
/**
 * Make an enum compatible with types -- in separate file because Logger/enums and Enum/index circular dependency
 * @param x - The enum
 * @returns The object proxy with error logger when a value is accessed outside of enum
 */
function makeEnum(x) {
    return x;
}
exports.makeEnum = makeEnum;
//# sourceMappingURL=enum.js.map